import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import _ from 'lodash';

export default class RegexInput extends React.Component {
  static propTypes = {
    regex: PropTypes.any.isRequired,
    className: PropTypes.string,
    regexType: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.node.isRequired
  };

  componentWillUpdate() {
    const node = ReactDOM.findDOMNode(this);
    // If we ignored input from the user in onChange, React will move
    // the cursor to the end of the line. Therefore, we must put the cursor back
    if (!this.props.regex.test(node.value) && node.selectionStart > 0) {
      const oldLength = node.value.length;
      const oldCursorLocation = node.selectionStart;
      node.value = this.props.value;
      const newCursorLocation = Math.max(0, node.value.length - oldLength + oldCursorLocation);
      node.selectionStart = newCursorLocation;
      node.selectionEnd = newCursorLocation;
    }
  }

  render() {
    const { value, onChange, className, regexType, regex, ...passed } = this.props;
    const props = _.omit(passed, ['addonLeft', 'addonRight']);

    return (
      <input
        {...props}
        value={value}
        type="text"
        className={classNames(className, 'form-control')}
        onChange={(e) => {
          if (regex.test(e.target.value) || !e.target.value) {
            if (regexType === 'currency' && e.target.value === '.') {
              onChange('0.');
            } else {
              onChange(e);
            }
          } else {
            const dirtyArray = e.target.value.split('');
            const cleanedArray = dirtyArray.filter(character => regex.test(character));
            const cleanedString = cleanedArray.join('');
            onChange(cleanedString);
          }
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/forms/inputs/regex.js